const APP_ENVS = ['local', 'test', 'dev', 'stage', 'prod'] as const;
export type AppEnv = (typeof APP_ENVS)[number];

export const isAppEnv = (value: unknown): value is AppEnv => {
    return typeof value === 'string' && APP_ENVS.some((env) => env === value);
};
